import {fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import type {StoreState} from "../features/store"
import {DOMAIN_API} from "./api"
import {applyAdminRequestHeaders} from "./apiHeaders"
import {isUnsecureUrl} from "./unsecureEndpoints"

export default fetchBaseQuery({
    baseUrl: DOMAIN_API,
    prepareHeaders: (headers, {getState, arg}) => {
        const rawUrl = typeof arg === "string" ? arg : arg?.url
        const token = (getState() as StoreState).auth?.token
        if (token && !isUnsecureUrl(rawUrl, DOMAIN_API)) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        return applyAdminRequestHeaders(headers)
    }
})
